exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Z3Qh{font-size:17px;font-weight:700;margin-bottom:15px}._21lJs{font-size:12px}._1iifk{display:inline-block;margin-right:20px;width:calc(50% - 20px);vertical-align:top}._1__c2{list-style:none;margin-left:0;padding-left:0}._32IH-{margin-bottom:30px}._1TEn2{padding-bottom:10px;font-size:16px;font-weight:700;margin:0}._1MfaW{margin:0;padding:0;padding-left:20px}._1MfaW,._3sZGk{list-style:initial}._3sZGk{font-size:14px;font-weight:300;line-height:150%}", ""]);

// exports
exports.locals = {
	"root": "_3CBXc",
	"title": "_2Z3Qh",
	"list": "_21lJs",
	"col": "_1iifk",
	"group": "_1__c2",
	"optionGroup": "_32IH-",
	"optionGroupTitle": "_1TEn2",
	"optionList": "_1MfaW",
	"option": "_3sZGk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertOptions/AdvertOptions.css
// module id = 3290
// module chunks = 32